import { InsuranceProduct } from "./insurance";
import { VehicleIncentive } from "src/app/settings-module/models/incentives";

interface Color {
  code: string;
  description: string;
}

interface Option {
  code: string;
  description: string;
  price: number;
  cost: number;
  residual: number;
}

export interface PBSCustomField {
  key: string;
  value: string;
  type: string;
}

export interface DealerAccessory {
  name: string;
  price: number;
}

export interface Order {
  invoiceNumber: string;
  price: number;
  status: string;
  estimatedCost: number;
  statusDate: string;
  description: string;
  locationStatus: string;
  locationStatusDate: string;
}

export interface Vehicle {
  stockNumber: string;
  year: string;
  make: string;
  model: string;
  carline: string;
  trim: string;
  vin: string;
  odometer: number;
  order: Order;
  imageUrl: string;
  stockPhoto: string;
  criticalMemo?: string;
  retail: number;
  modelNumber: string;
  customFields: PBSCustomField[];
  insuranceProducts: InsuranceProduct[];
  incentives: VehicleIncentive[];
  vehicleType: string;
  bodyStyle: string
  exteriorColor: Color;
  msr: number;
  lot: string;
  isCertified?: boolean;
  isUsed?: boolean;
  options: Option[];
  engine: string;
  inventory: number;
  mpg: number;
  sold: boolean;
}

export interface VehicleWithCondition extends Vehicle {
  condition: string;
}

export enum VehicleUnavailableError {
  NotAvailableForSale = 'stock_number_not_available_for_sale',
  UsedMissingCategory = 'stock_number_used_missing_category'
}